import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import {
  Snackbar,
  makeStyles,
  createStyles,
  SnackbarContent,
} from '@material-ui/core';

import { amber, green } from '@material-ui/core/colors';

const useStyles1 = makeStyles(theme => createStyles({
  success: {
    backgroundColor: green[600],
    zIndex: '9',
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.main,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const SnackbarComponent = (props) => {
  const {
    msg,
    variant,
    openProps,
    callback,
    verticalAlign,
  } = props;

  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(openProps);
  }, [openProps]);

  const classes = useStyles1();

  const handleClose = (event, reason) => {
    if (callback) callback();
    if (reason === 'clickaway') setOpen(false);
    setOpen(false);
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{
          vertical: verticalAlign,
          horizontal: 'left',
        }}
        open={open}
        onClose={handleClose}
        ContentProps={{
          'aria-describedby': 'message-id',
        }}
      >
        <SnackbarContent
          className={clsx(classes[variant])}
          aria-describedby="client-snackbar"
          message={<span id="message-id">{msg}</span>}
        />
      </Snackbar>
    </>
  );
};


SnackbarComponent.defaultProps = {
  callback: false,
  verticalAlign: 'bottom',
};

SnackbarComponent.propTypes = {
  msg: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['error', 'info', 'success', 'warning']).isRequired,
  verticalAlign: PropTypes.oneOf(['top', 'bottom']),
  openProps: PropTypes.bool.isRequired,
  callback: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.func,
  ]),
};

export default SnackbarComponent;
